import { get } from 'lodash';
import { prepareSearchData, SORT_DESC } from '../helpers/prepareSearchData';
import { apiClient, handleError } from '../api/ApiClient';

import {
  SEARCH_TRANSACTIONS,
  SEARCH_TRANSACTIONS_FAILURE,
  SEARCH_TRANSACTIONS_SUCCESS,
} from './TransactionsReducer';
import { showAlert } from '../common/components/alert/AlertActions';
import AlertVariant from '../common/components/alert/AlertVariant';

const DEALER_ENDPOINT = '/dealer';
const INVOICE_NOT_FOUND_MESSAGE = 'Invoice not found. Please try again later.';

export const searchTransactions = (values) => (dispatch) => {
  const preparedValues = {
    ...values,
    feeInPence: values.feeInPence ? String(Number(values?.feeInPence) * 100) : '',
  };

  return apiClient
    .post(
      `${DEALER_ENDPOINT}/transactions`,
      prepareSearchData(preparedValues, { createdOn: SORT_DESC }),
    )
    .then((res) => {
      dispatch({ type: SEARCH_TRANSACTIONS });
      if (res.status === 200) {
        dispatch({
          type: SEARCH_TRANSACTIONS_SUCCESS,
          payload: {
            items: get(res, 'data.data.content', []),
            totalItems: get(res, 'data.data.totalElements', 0),
          },
        });
      }
    })
    .catch((err) => {
      dispatch(handleError(err));
      dispatch({ type: SEARCH_TRANSACTIONS_FAILURE });
    });
};

export const generateTransactionsCSV = (values) => (dispatch) => {
  const preparedValues = {
    ...values,
    feeInPence: values.feeInPence ? String(Number(values?.feeInPence) * 100) : '',
  };

  return apiClient
    .post(
      `${DEALER_ENDPOINT}/transactions/generate`,
      prepareSearchData(preparedValues, { createdOn: SORT_DESC }),
    )
    .then((res) => {
      if (res.status === 200) {
        const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
        const a = document.createElement('a');
        a.href = url;
        a.download = 'TransactionsReport.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    })
    .catch((err) => {
      dispatch(handleError(err));
    });
};

export const refundTransaction = (id, callback) => (dispatch) =>
  apiClient
    .post(`${DEALER_ENDPOINT}/transactions/${id}/refund`)
    .then((res) => {
      if (res.status !== 200)
        dispatch(
          showAlert(
            'The transaction could not be refunded. Please try again later.',
            AlertVariant.DANGER,
          ),
        );
      dispatch(
        showAlert('The transaction has been successfully refunded', AlertVariant.SUCCESS),
      );
      if (typeof callback === 'function') callback();
    })
    .catch((err) => {
      dispatch(handleError(err));
    });

export const downloadTransactionInvoice = (transactionId) => (dispatch) =>
  apiClient
    .get(`/dealer/transactions/${transactionId}/invoice/download`, { responseType: 'blob' })
    .then((res) => downloadBlob(res, 'invoice.pdf', dispatch))
    .catch(() => {
      dispatch(handleError(INVOICE_NOT_FOUND_MESSAGE));
    });

export const downloadTransactionInvoiceCreditNote = (transactionId) => (dispatch) =>
  apiClient
    .get(`/dealer/transactions/${transactionId}/invoice/credit-note/download`, {
      responseType: 'blob',
    })
    .then((res) => downloadBlob(res, 'credit-note.pdf', dispatch))
    .catch(() => {
      dispatch(handleError(INVOICE_NOT_FOUND_MESSAGE));
    });

const downloadBlob = (res, file) => {
  if (res.status === 200) {
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = file;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
};
